export const summary = {
  pathname: '/api/v4/experimental/search/conversation',
  method: 'POST',
  headers: {
    'content-type': 'application/json'
  },
  body: (payload) => payload
}

export const summaryFeedback = {
  pathname: '/api/v4/experimental/search/conversation/feedback',
  method: 'POST',
  headers: {
    'content-type': 'application/json'
  },
  body: ({ feedback }) => feedback
}
